/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { HTTPValidationError } from "./HTTPValidationError.ts";

export const getAddressesLatestTxidV1BitcoinAddressesLatestTxidPostQueryParamsNetworkEnum =
	{
		REGTEST: "REGTEST",
		MAINNET: "MAINNET",
	} as const;

export type GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPostQueryParamsNetworkEnum =
	(typeof getAddressesLatestTxidV1BitcoinAddressesLatestTxidPostQueryParamsNetworkEnum)[keyof typeof getAddressesLatestTxidV1BitcoinAddressesLatestTxidPostQueryParamsNetworkEnum];

export type GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPostQueryParams =
	{
		/**
		 * @type string
		 */
		network: GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPostQueryParamsNetworkEnum;
	};

/**
 * @description Successful Response
 */
export type GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPost200 = {
	[key: string]: string | null;
};

/**
 * @description Validation Error
 */
export type GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPost422 =
	HTTPValidationError;

export type GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPostMutationRequest =
	string[];

export type GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPostMutationResponse =
	GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPost200;

export type GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPostMutation = {
	Response: GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPost200;
	Request: GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPostMutationRequest;
	QueryParams: GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPostQueryParams;
	Errors: GetAddressesLatestTxidV1BitcoinAddressesLatestTxidPost422;
};
